module.exports = __webpack_public_path__ + "static/media/tenacidade.e862b20e.jpg";